
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/itinerary/[slug]",
      function () {
        return require("private-next-pages/itinerary/[slug].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/itinerary/[slug]"])
      });
    }
  